export default __webpack_public_path__ + "97aa05668c2a7a526495beeaaa7a7f5d.webp";